import { useState } from "react";
import "../assets/TransfersComponent.css";

export default function TransfersComponent({ transfersHTML }) {
  const [expandedStop, setExpandedStop] = useState(null);

  if (!transfersHTML) {
    console.log('TransfersComponent - no transfersHTML provided');
    return null;
  }

  return (
    <div className="transfers-component" id="route-transfers">
      <div 
        className="transfers-content"
        dangerouslySetInnerHTML={{ __html: transfersHTML }}
      />
    </div>
  );
} 